export const dependencyMap = {
  oak: {
    cove: {
      abstract: { hamilton: {}, hayman: {} },
      fluted: { hamilton: {}, hayman: {} },
      timber: { hamilton: {}, hayman: {} },
    },
    dune: {
      abstract: { balmoral: {}, hamilton: {}, hayman: {}, kimberly: {} },
      fluted: { balmoral: {}, hamilton: {}, hayman: {}, kimberly: {} },
      timber: { balmoral: {}, hamilton: {}, hayman: {}, kimberly: {} },
    },
    haven: {
      abstract: { balmoral: {}, hamilton: {}, hayman: {} },
      fluted: { balmoral: {}, hamilton: {}, hayman: {} },
      timber: { balmoral: {}, hamilton: {}, hayman: {} },
    },
    oyster: {
      abstract: { balmoral: {} },
      fluted: { balmoral: {} },
      timber: { balmoral: {} },
    },
  },
  teak: {
    cove: {
      abstract: { hamilton: {}, hayman: {} },
      fluted: { hamilton: {}, hayman: {} },
      timber: { hamilton: {}, hayman: {} },
    },
    dune: {
      abstract: { hamilton: {}, hayman: {}, kimberly: {} },
      fluted: { hamilton: {}, hayman: {}, kimberly: {} },
      timber: { hamilton: {}, hayman: {}, kimberly: {} },
    },
    haven: {
      abstract: { balmoral: {}, hamilton: {}, hayman: {} },
      fluted: { balmoral: {}, hamilton: {}, hayman: {} },
      timber: { balmoral: {}, hamilton: {}, hayman: {} },
    },
    oyster: {
      abstract: { balmoral: {} },
      fluted: { balmoral: {} },
      timber: { balmoral: {} },
    },
  },
  walnut: {
    cove: {
      abstract: { hamilton: {}, hayman: {} },
      fluted: { hamilton: {}, hayman: {} },
      timber: { hamilton: {}, hayman: {} },
    },
    dune: {
      abstract: { balmoral: {}, hamilton: {}, hayman: {}, kimberly: {} },
      fluted: { balmoral: {}, hamilton: {}, hayman: {}, kimberly: {} },
      timber: { balmoral: {}, hamilton: {}, hayman: {}, kimberly: {} },
    },
    haven: {
      abstract: { balmoral: {}, hamilton: {}, hayman: {} },
      fluted: { balmoral: {}, hamilton: {}, hayman: {} },
      timber: { balmoral: {}, hamilton: {}, hayman: {} },
    },
    oyster: {
      abstract: { balmoral: {} },
      fluted: { balmoral: {} },
      timber: { balmoral: {} },
    },
  },
};
